module.exports = __webpack_public_path__ + "static/media/Details_Button@3x.840226ed.png";